export default "__VITE_ASSET__BgDV8396__"